import React, { useEffect, useState } from "react";
import "../../../styles/orderlist.css";
import { motion } from "framer-motion";
import { LocalStorageUtils } from "utils/localstorage.utils";
import { OrderApi } from "api/order.api";
import Loader from "components/loader/loader";
import { ToastContainer } from "react-toastify";
import OrderItemSummary from "./orderItemSummary";

const AllOrders = () => {
  const [orderList, setOrderList] = useState([]);
  const [authToken, setAuthToken] = useState(
    LocalStorageUtils.get(LocalStorageUtils.LOCAL_STORAGE_KEY.AUTH_TOKEN)
  );
  const [loading, setLoading] = useState(true);

  const fetchOrders = () => {
    setLoading(true);
    OrderApi.getOrders().then((response) => {
      setOrderList(response.orders);
      setLoading(false);
    });
  };
  useEffect(() => {
    if (authToken) {
      setLoading(true);
      fetchOrders();
    }
  }, [authToken]);

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="all_order_container"
      >
        <h1 className="all_order_title">Your Orders</h1>
        <div className="all_order_list">
          {!authToken && <div>Please login to view your orders</div>}
          {authToken && loading && <Loader />}
          {!loading && orderList?.length === 0 && <div>No orders found</div>}
          {orderList?.map((order) => (
            <OrderItemSummary
              order={order}
              onOrderFeedbackSubmitted={() => {
                fetchOrders();
              }}
            />
          ))}
        </div>
      </motion.div>
      <ToastContainer
        id="cart-toast-container"
        style={{ width: "300px" }}
        position="top-center"
        autoClose={3000}
      />
    </>
  );
};

export default AllOrders;
